import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { Button, StandAloneLink } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { NoAppointmentsAvailable } from '@app/components/ScheduleInstallation';
import { ScheduleInstallationContext, useScreenResolution } from '@app/hooks';
import { submitOrder } from '@app/redux/changePlan';

import styles from './styles.module.scss';

type NoAppointmentsProps = {
  handleBackNavigation: (e: React.MouseEvent<HTMLElement>) => void;
};

type ExtendedScheduleInstallationContext = {
  textInput: string;
  phoneNumberInput: string;
};

const NoAppointments = ({ handleBackNavigation }: NoAppointmentsProps) => {
  const { t } = useTranslation('ScheduleInstallation');
  const dispatch = useDispatch();

  const { isLarge, isExtraLarge } = useScreenResolution();
  const isDesktop = isLarge || isExtraLarge;

  const { textInput, phoneNumberInput } = useContext(
    ScheduleInstallationContext
  ) as ExtendedScheduleInstallationContext;

  const handleSubmitWithoutAppointment = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.preventDefault();
    const content = `${textInput} ${phoneNumberInput}`;
    dispatch(submitOrder({ notes: content }));
  };

  return (
    <div className={styles['no-appointments-container']}>
      <NoAppointmentsAvailable description={t('ChangePlan:scheduleInstallation.errorContent')} />
      {isDesktop && (
        <>
          <hr />

          <div className={styles['no-appointments-footer']}>
            <StandAloneLink href="#" underline={true} data-cy="back-button" onClick={handleBackNavigation}>
              {t('backToPlanReview')}
            </StandAloneLink>

            <Button onClick={handleSubmitWithoutAppointment} data-cy="no-appointment-place-order">
              {t('contactInformation.placeOrder')}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default NoAppointments;
